import * as yup from "yup";

export const BankAccountInfoFormValidationSchema = yup.object().shape({
  accountNumber: yup
    .number()
    .positive("Account Number must be a positive number")
    .typeError("Account Number must be a number")
    .required("Account Number is required"),
  bankName: yup.string().required("Please select a Bank"),
});
